import * as fflate from 'fflate';

/* istanbul ignore next */
export const decompress = (file: ArrayBuffer) => fflate.decompressSync(new Uint8Array(file));
